import { Contact } from '../../components/address-book';
import {
  AddressSelectionContextState,
  AddressSelectionStatus,
  AddressSelectionType,
  Dispatch,
} from './address-selection-types';

const setAddressSelectionSender = (dispatch: Dispatch, sender: Contact) => {
  dispatch({
    type: AddressSelectionType.SET_SENDER,
    payload: sender,
  });
};

const setAddressSelectionContacts = (dispatch: Dispatch, contacts: Contact[]) => {
  dispatch({
    type: AddressSelectionType.SET_CONTACTS,
    payload: contacts,
  });
};

const setAddressSelectionCount = (dispatch: Dispatch, count: number) => {
  dispatch({
    type: AddressSelectionType.SET_COUNT,
    payload: count,
  });
};

const resetAddressSelectionCount = (dispatch: Dispatch) => {
  dispatch({
    type: AddressSelectionType.RESET_COUNT,
  });
};

const resetAddresses = (dispatch: Dispatch, state: AddressSelectionContextState) => {
  dispatch({
    type: AddressSelectionType.RESET_ADDRESSES,
    payload: state,
  });
};

const increaseAddressSelectionCount = (dispatch: Dispatch) => {
  dispatch({
    type: AddressSelectionType.INCREASE_COUNT,
  });
};

const decreaseAddressSelectionCount = (dispatch: Dispatch) => {
  dispatch({
    type: AddressSelectionType.DECREASE_COUNT,
  });
};

const setAddressSelectionMaxCount = (dispatch: Dispatch, maxCount: number) => {
  dispatch({
    type: AddressSelectionType.SET_MAX_COUNT,
    payload: maxCount,
  });
};

const setAddressSelectionIsMaxCountReached = (dispatch: Dispatch, isMaxCountReached: boolean) => {
  dispatch({
    type: AddressSelectionType.SET_IS_MAX_COUNT_REACHED,
    payload: isMaxCountReached,
  });
};

const setAddressSelectionStatus = (dispatch: Dispatch, status: AddressSelectionStatus) => {
  dispatch({
    type: AddressSelectionType.SET_STATUS,
    payload: status,
  });
};

export {
  setAddressSelectionSender,
  setAddressSelectionContacts,
  setAddressSelectionCount,
  resetAddressSelectionCount,
  resetAddresses,
  increaseAddressSelectionCount,
  decreaseAddressSelectionCount,
  setAddressSelectionMaxCount,
  setAddressSelectionIsMaxCountReached,
  setAddressSelectionStatus,
};
